<template>
  <b-form-group :label="label" :label-for="inputId" :description="description">
    <b-form-select
      :id="inputId"
      v-model="internalValue"
      :options="stateOptions"
      :required="required"
      :state="isValid"
      @change="handleChange"
      @blur="handleBlur"
    >
      <option disabled value="">Selecione...</option>
    </b-form-select>
    <b-form-invalid-feedback :id="`${inputId}-feedback`">
      {{ invalidFeedback }}
    </b-form-invalid-feedback>
  </b-form-group>
</template>

<script>
export default {
  name: 'StateSelect',
  props: {
    value: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '*Estado',
    },
    inputId: {
      type: String,
      default: 'state-select-input',
    },
    description: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: true,
    },
    invalidFeedback: {
      type: String,
      default: 'Por favor, selecione um estado.',
    },
    validationFunc: {
      type: Function,
      default: null,
    },
    state: {
      type: Boolean,
      default: null,
    },
  },
  data() {
    return {
      internalValue: this.value,
      isValid: this.state,
      stateOptions: [
        { value: '', text: 'Selecione...' },
        { value: 'AC', text: 'Acre' },
        { value: 'AL', text: 'Alagoas' },
        { value: 'AM', text: 'Amazonas' },
        { value: 'AP', text: 'Amapá' },
        { value: 'BA', text: 'Bahia' },
        { value: 'CE', text: 'Ceará' },
        { value: 'DF', text: 'Distrito Federal' },
        { value: 'ES', text: 'Espírito Santo' },
        { value: 'GO', text: 'Goiás' },
        { value: 'MA', text: 'Maranhão' },
        { value: 'MT', text: 'Mato Grosso' },
        { value: 'MS', text: 'Mato Grosso do Sul' },
        { value: 'MG', text: 'Minas Gerais' },
        { value: 'PA', text: 'Pará' },
        { value: 'PB', text: 'Paraíba' },
        { value: 'PR', text: 'Paraná' },
        { value: 'PE', text: 'Pernambuco' },
        { value: 'PI', text: 'Piauí' },
        { value: 'RJ', text: 'Rio de Janeiro' },
        { value: 'RN', text: 'Rio Grande do Norte' },
        { value: 'RS', text: 'Rio Grande do Sul' },
        { value: 'RO', text: 'Rondônia' },
        { value: 'RR', text: 'Roraima' },
        { value: 'SC', text: 'Santa Catarina' },
        { value: 'SP', text: 'São Paulo' },
        { value: 'SE', text: 'Sergipe' },
        { value: 'TO', text: 'Tocantins' },
      ],
    };
  },
  watch: {
    value(newVal) {
      this.internalValue = newVal;
      this.validate();
    },
    state(newVal) {
      this.isValid = newVal;
    },
  },
  methods: {
    handleChange() {
      this.$emit('input', this.internalValue);
      this.validate();
    },
    handleBlur() {
      this.validate();
    },
    validate() {
      if (!this.validationFunc) {
        this.isValid = this.required ? !!this.internalValue : null;
      } else {
        this.isValid = this.validationFunc(this.internalValue);
      }
      this.$emit('validation-updated', this.isValid);
    },
  },
};
</script>
